'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthEmailPayload(email) {
  this.En = null;
  this.En = email;
}
export { $c_Lpresto_types$TwoFactorAuthEmailPayload as $c_Lpresto_types$TwoFactorAuthEmailPayload };
$p = $c_Lpresto_types$TwoFactorAuthEmailPayload.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthEmailPayload;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthEmailPayload() {
}
export { $h_Lpresto_types$TwoFactorAuthEmailPayload as $h_Lpresto_types$TwoFactorAuthEmailPayload };
$h_Lpresto_types$TwoFactorAuthEmailPayload.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_types$TwoFactorAuthEmailPayload) && (this.En === x$0.En)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "TwoFactorAuthEmailPayload";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.En;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$TwoFactorAuthEmailPayload(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.km)));
}
export { $isArrayOf_Lpresto_types$TwoFactorAuthEmailPayload as $isArrayOf_Lpresto_types$TwoFactorAuthEmailPayload };
var $d_Lpresto_types$TwoFactorAuthEmailPayload = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthEmailPayload, "presto.types$TwoFactorAuthEmailPayload", ({
  km: 1,
  ee: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$TwoFactorAuthEmailPayload as $d_Lpresto_types$TwoFactorAuthEmailPayload };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Email-Payload.js.map
